import { Component } from "@angular/core";

@Component({
    templateUrl: 'add-action-modal.html',
    standalone: false
})
export class AddActionModal {

  possibleActions = [
    [
      {
        "id": 1,
        "title": "Google Contacts",
        "action": "row_custom_query",
        "order": 2,
        "configs": {
          "authentication_id": "8132",
          "logo": "https://zapier-images.imgix.net/storage/developer_cli/502b72f4cd53817e8ff0b147831d90c6.png",
          "name": "Event Name",
          "description": "Event Description"
        },
        "params": [
          {
            "key": "key1",
            "title": "Parameter 1",
            "description": "Description for Parameter 1",
            "value": "value3",
            "order": 1,
            "required": true,
            "type": "text",
          },
          {
            "key": "key2",
            "title": "Parameter 2",
            "description": "Description for Parameter 2",
            "value": ["option1", "option2"],
            "order": 2,
            "required": false,
            "type": "multiselect",
            "options": ["option1", "option2", "option3"].map((option) => ({ value: option, viewValue: option }) ),
          }
        ]
      },
      {
        "id": 2,
        "title": "action title 2",
        "action": "update_row",
        "order": 3,
        "configs": {
          "authentication_id": "8132",
          "logo": "https://cdn.cdnlogo.com/logos/o/14/official-gmail-icon-2020.svg",
          "name": "Event Name",
          "description": "Event Description"
        },
        "params": [
          {
            "key": "key1",
            "title": "Parameter 1",
            "description": "Description for Parameter 1",
            "value": "value3",
            "order": 1,
            "required": true,
            "type": "text"
          },
          {
            "key": "key2",
            "title": "Parameter 2",
            "description": "Description for Parameter 2",
            "value": ["option1", "option2"],
            "order": 2,
            "required": false,
            "type": "multiselect",
            "options": ["option1", "option2", "option3"].map((option) => ({ value: option, viewValue: option }) ),
          }
        ]
      }
    ]
  ]
  constructor() {
  }
}
